import React, { useState } from "react";
import { Box, TextField, MenuItem, Button } from "@mui/material";
import DateInput from "./DateInput";
import dayjs from "dayjs";

const categories = ["auth", "user", "order", "system", "payment"];
const levels = ["info", "warn", "error"];

const LogsFilters = ({ filters, setFilters, resetPage }) => {
  const [startDate, setStartDate] = useState(filters.startDate || null);
  const [endDate, setEndDate] = useState(filters.endDate || null);
  const [category, setCategory] = useState(filters.category || "");
  const [level, setLevel] = useState(filters.level || "");
  const [userId, setUserId] = useState(filters.userId || "");

  const applyFilters = () => {
    setFilters({
      startDate: startDate ? dayjs(startDate).toISOString() : undefined,
      endDate: endDate ? dayjs(endDate).toISOString() : undefined,
      category,
      level,
      userId,
    });
    resetPage();
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
      <TextField
        label="Category"
        select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        sx={{ minWidth: 150 }}>
        <MenuItem value="">All</MenuItem>
        {categories.map((cat) => (
          <MenuItem key={cat} value={cat}>
            {cat}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Level"
        select
        value={level}
        onChange={(e) => setLevel(e.target.value)}
        sx={{ minWidth: 120 }}>
        <MenuItem value="">All</MenuItem>
        {levels.map((lvl) => (
          <MenuItem key={lvl} value={lvl}>
            {lvl}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="User ID"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        sx={{ minWidth: 200 }}
      />

      <DateInput
        label="Start Date"
        value={startDate}
        onChange={(newValue) => setStartDate(newValue)}
      />
      <DateInput
        label="End Date"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
      />

      <Button variant="contained" onClick={applyFilters}>
        Apply
      </Button>
    </Box>
  );
};

export default LogsFilters;
